export default __webpack_public_path__ + "static/media/bg-2.58dd5123.png";